import React, { Component } from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';

class AmpEnvelopeComponent extends Component {
    render() {
        let instrument = this.props.instrument;
        return (
            <div>
                  <EffectParameterSlider
                    automation={this.props.automation}
                    name={'Amp Attack'}
                    instrument={instrument}
                    parameter={instrument.ampAttackParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    min={0}
                    max={6000}
                    step={1}
                    />
                  <EffectParameterSlider
                    automation={this.props.automation}
                    name={'Amp Decay'}
                    instrument={instrument}
                    parameter={instrument.ampDecayParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    min={0}
                    max={6000}
                    step={1}
                    />
                   <EffectParameterSlider
                    automation={this.props.automation}
                    name={'Amp Sustain'}
                    instrument={instrument}
                    parameter={instrument.ampSustainParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    min={0}
                    max={1}
                    step={0.01}
                    />
                   <EffectParameterSlider
                    automation={this.props.automation}
                    name={'Amp Release'}
                    instrument={instrument}
                    parameter={instrument.ampReleaseParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    min={0}
                    max={10000}
                    step={1}
                    />
            </div>
        );
    }
}

export default AmpEnvelopeComponent;
